import React from "react";

function Wizard({ children, step, details, isOpen, isDone, onClickHeader }) {
  return (
    <div className="bg-white max-w-[867px] mx-auto rounded-b-lg shadow-[0_4px_30px_0_#0606110F] cursor-pointer">
      <div
        className={`px-5 py-3 border-b border-grey-2 w-full ${
          isOpen || isDone
            ? "bg-[linear-gradient(90deg,_#6967F5_0%,_#745DB9_100%)]"
            : "bg-[#ECEBF5]"
        } ${!isOpen ? "rounded-lg " : "rounded-t-lg "}`}
        onClick={() => onClickHeader?.()}
      >
        <div className="flex gap-2.5 items-center">
          <div
            className={`bg-white rounded-full flex items-center justify-center w-8 h-8 ${
              isOpen || isDone ? "" : "border border-pri"
            }`}
          >
            <p className="p-xs mb-0 font-medium text-main">{step}</p>
          </div>
          <p
            className={`p-xs mb-0 font-medium ${
              isOpen || isDone ? "text-white" : "text-dark"
            }`}
          >
            {details}
          </p>
        </div>
      </div>
      {isOpen && <div className="w-full mt-7">{children}</div>}
    </div>
  );
}

export default Wizard;
